// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --menu-bg: #f7fafc;
  --header-bg: #173f63;
  --primary-color: #2478c7;
  --text-main: #26323f;
  --text-light: #64748b;
  --item-hover: #eef7ff;
  --item-selected-bg: #e8f4ff;
  --item-selected-text: #1f6dae;
}

.mobile-web-block {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: max(24px, env(safe-area-inset-top)) 20px max(24px, env(safe-area-inset-bottom));
  background: linear-gradient(180deg, rgba(23, 63, 99, 0.96) 0%, rgba(36, 120, 199, 0.96) 100%);
}

.mobile-web-panel {
  width: min(100%, 380px);
  text-align: center;
  color: #ffffff;
}
.mobile-web-panel h1 {
  margin: 18px 0 10px;
  font-size: 24px;
  line-height: 1.18;
  font-weight: 900;
  letter-spacing: 0;
}
.mobile-web-panel p {
  margin: 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 15px;
  line-height: 1.55;
}
.mobile-web-panel small {
  display: block;
  margin-top: 16px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
  line-height: 1.45;
}

.mobile-web-icon {
  width: 76px;
  height: 76px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.24);
}
.mobile-web-icon ion-icon {
  font-size: 40px;
}

.mobile-web-primary {
  width: 100%;
  min-height: 52px;
  margin-top: 24px;
  border: 0;
  border-radius: 14px;
  background: #ffffff;
  color: #173f63;
  font-size: 15px;
  font-weight: 900;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.22);
}

.mobile-web-desktop-access {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.16);
}
.mobile-web-desktop-access span {
  color: rgba(255, 255, 255, 0.78);
  font-size: 12px;
  font-weight: 700;
}
.mobile-web-desktop-access strong {
  color: #ffffff;
  font-size: 16px;
  overflow-wrap: anywhere;
  -webkit-user-select: all;
          user-select: all;
}

.mobile-web-copy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 40px;
  margin-top: 4px;
  padding: 0 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
}
.mobile-web-copy ion-icon {
  font-size: 18px;
}

.access-expired-overlay {
  align-items: center;
  backdrop-filter: blur(7px);
  background: rgba(15, 23, 42, 0.72);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: 20px;
  position: fixed;
  z-index: 100000;
}

.access-expired-card {
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 24px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.32);
  max-width: 430px;
  overflow: hidden;
  padding: 32px;
  position: relative;
  text-align: center;
  width: 100%;
}
.access-expired-card h1 {
  color: #1e293b;
  font-size: 24px;
  line-height: 1.2;
  margin: 8px 0 9px;
}
.access-expired-card > p {
  color: #64748b;
  font-size: 14px;
  line-height: 1.55;
  margin: 0 auto 20px;
  max-width: 340px;
}
.access-expired-card > button {
  background: linear-gradient(135deg, #6557e8, #5044d8);
  border: 0;
  border-radius: 12px;
  box-shadow: 0 10px 22px rgba(101, 87, 232, 0.26);
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  min-height: 46px;
  width: 100%;
}

.access-expired-decoration {
  border-radius: 50%;
  pointer-events: none;
  position: absolute;
}

.access-expired-decoration-one {
  background: rgba(101, 87, 232, 0.08);
  height: 150px;
  right: -70px;
  top: -70px;
  width: 150px;
}

.access-expired-decoration-two {
  background: rgba(239, 68, 68, 0.06);
  bottom: -55px;
  height: 120px;
  left: -55px;
  width: 120px;
}

.access-expired-icon {
  align-items: center;
  background: linear-gradient(145deg, #fff1f2, #ffe4e6);
  border: 1px solid #fecdd3;
  border-radius: 20px;
  color: #e11d48;
  display: flex;
  height: 68px;
  justify-content: center;
  margin: 0 auto 14px;
  position: relative;
  width: 68px;
}
.access-expired-icon ion-icon {
  font-size: 34px;
}

.access-expired-eyebrow {
  color: #e11d48;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.access-expired-date {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 13px;
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 10px;
  padding: 11px;
  position: relative;
}
.access-expired-date ion-icon {
  color: #6557e8;
  font-size: 21px;
}
.access-expired-date small, .access-expired-date strong {
  display: block;
}
.access-expired-date small {
  color: #94a3b8;
  font-size: 9px;
  text-transform: uppercase;
}
.access-expired-date strong {
  color: #334155;
  font-size: 14px;
  margin-top: 1px;
}

.access-expired-guidance {
  align-items: flex-start;
  background: #f3f1ff;
  border: 1px solid #ddd8ff;
  border-radius: 13px;
  color: #554c9f;
  display: flex;
  font-size: 12px;
  gap: 8px;
  line-height: 1.45;
  margin-bottom: 18px;
  padding: 11px;
  position: relative;
  text-align: left;
}
.access-expired-guidance ion-icon {
  flex: 0 0 auto;
  font-size: 19px;
}

ion-menu.custom-menu ion-content {
  --background: var(--menu-bg);
}

.menu-header {
  background: linear-gradient(135deg, #173f63 0%, #2478c7 100%);
  padding: 40px 20px 25px 20px;
  color: #ffffff;
  border-bottom-right-radius: 30px;
  margin-bottom: 10px;
  box-shadow: 0 14px 28px rgba(23, 63, 99, 0.22);
  position: relative;
  overflow: hidden;
}
.menu-header::after {
  content: "";
  position: absolute;
  right: -34px;
  bottom: -42px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(33, 166, 122, 0.28);
}
.menu-header .user-avatar-container {
  margin-bottom: 15px;
}
.menu-header .user-avatar-container .avatar-circle {
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--header-bg);
  font-weight: 800;
  font-size: 24px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.menu-header .user-details {
  position: relative;
  z-index: 1;
}
.menu-header .user-details .user-name {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.menu-header .user-details .user-email {
  margin: 4px 0 10px;
  font-size: 13px;
  opacity: 0.9;
  font-weight: 500;
}
.menu-header .user-details .access-validity {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 9px;
  color: #eff6ff;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  gap: 5px;
  margin: 0 0 10px;
  padding: 6px 8px;
}
.menu-header .user-details .access-validity ion-icon {
  font-size: 14px;
}
.menu-header .user-details .access-validity.expired {
  background: rgba(127, 29, 29, 0.3);
  border-color: rgba(254, 202, 202, 0.5);
  color: #fff1f2;
}
.menu-header .user-details .status-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.menu-header .user-details .status-row .badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.menu-header .user-details .status-row .badge ion-icon {
  margin-right: 4px;
  font-size: 12px;
}
.menu-header .user-details .status-row .badge.verified {
  background: rgba(255, 255, 255, 0.16);
  color: #d9fff0;
  border: 1px solid rgba(217, 255, 240, 0.55);
}
.menu-header .user-details .status-row .badge.unverified {
  background: rgba(255, 71, 87, 0.2);
  color: #ff4757;
  border: 1px solid #ff4757;
}
.menu-header .user-details .status-row .badge.current-plan {
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.42);
}
.menu-header .user-details .status-row .badge.premium {
  background: #fff5d7;
  color: #8a5a00;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
}
.menu-header .user-details .plan-date {
  font-size: 11px;
  color: #ffd32a;
  margin: 0;
}

.menu-items-container {
  padding: 10px 16px;
}
.menu-items-container .section-title {
  padding: 20px 10px 5px;
  font-size: 12px;
  text-transform: uppercase;
  color: #7a8da4;
  font-weight: 700;
  letter-spacing: 1px;
}
.menu-items-container ion-list {
  background: transparent;
  padding: 0;
}
.menu-items-container .menu-item {
  --background: #ffffff;
  --min-height: 48px;
  --padding-start: 12px;
  --inner-padding-end: 12px;
  margin-bottom: 6px;
  border-radius: 12px;
  transition: all 0.2s ease;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.035);
}
.menu-items-container .menu-item ion-icon {
  color: #6b8aab;
  font-size: 22px;
  margin-right: 12px;
}
.menu-items-container .menu-item ion-label {
  font-weight: 500;
  font-size: 15px;
  color: var(--text-main);
}
.menu-items-container .menu-item .label-badge-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}
.menu-items-container .menu-item .label-badge-container ion-label {
  min-width: 0;
}
.menu-items-container .menu-item .label-badge-container .mini-badge {
  background: #e8f4ff;
  color: #2478c7;
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: bold;
  flex-shrink: 0;
  letter-spacing: 0;
}
.menu-items-container .menu-item .label-badge-container .mini-badge.beta-badge {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #b45309;
}
.menu-items-container .menu-item.selected {
  --background: var(--item-selected-bg);
  box-shadow: 0 10px 20px rgba(36, 120, 199, 0.14);
}
.menu-items-container .menu-item.selected ion-icon {
  color: var(--item-selected-text);
}
.menu-items-container .menu-item.selected ion-label {
  color: var(--item-selected-text);
  font-weight: 700;
}
.menu-items-container .menu-item.highlight-item {
  --background: #fff8e5;
}
.menu-items-container .menu-item.highlight-item ion-icon {
  color: #b7791f;
}
.menu-items-container .menu-item.highlight-item ion-label {
  color: #8a5a00;
  font-weight: 700;
}
.menu-items-container .menu-item.highlight-item.selected {
  --background: var(--item-selected-bg);
}
.menu-items-container .menu-item.highlight-item.selected ion-icon,
.menu-items-container .menu-item.highlight-item.selected ion-label {
  color: var(--item-selected-text);
}
.menu-items-container .menu-item.logout-item {
  margin-top: 15px;
  border: 1px solid #ffe2e5;
  --background: #fff7f8;
}
.menu-items-container .menu-item.logout-item ion-icon {
  color: #ff4757;
}
.menu-items-container .menu-item.logout-item ion-label {
  color: #ff4757;
}

.menu-footer {
  text-align: center;
  padding: 30px 0 10px;
}
.menu-footer p {
  font-size: 12px;
  color: #8ea0b4;
  margin: 0 0 5px;
}
.menu-footer .links-row {
  font-size: 11px;
  color: var(--primary-color);
  font-weight: 600;
}
.menu-footer .links-row span {
  cursor: pointer;
  padding: 5px;
}

@media (min-width: 1024px) {
  ion-menu.custom-menu {
    --width: 320px;
    --max-width: 320px;
    --background: #f8fafc;
    --box-shadow: 18px 0 45px rgba(15, 23, 42, 0.18);
  }
  ion-menu.custom-menu::part(container) {
    border-top-right-radius: 22px;
    border-bottom-right-radius: 22px;
    overflow: hidden;
    border-right: 1px solid rgba(36, 120, 199, 0.16);
    box-shadow: 18px 0 45px rgba(15, 23, 42, 0.18);
  }
  ion-menu.custom-menu ion-content {
    --background: linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);
  }
  .menu-header {
    margin: 14px 14px 8px;
    padding: 24px 18px 20px;
    border-radius: 18px;
    border-bottom-right-radius: 18px;
    background: linear-gradient(145deg, rgba(23, 63, 99, 0.96) 0%, rgba(36, 120, 199, 0.94) 100%);
    box-shadow: 0 16px 32px rgba(23, 63, 99, 0.22);
  }
  .menu-header::after {
    right: -42px;
    bottom: -54px;
    width: 140px;
    height: 140px;
    background: rgba(33, 166, 122, 0.26);
  }
  .menu-header .user-details .user-name {
    font-size: 18px;
    letter-spacing: 0;
  }
  .menu-header .user-details .user-email {
    max-width: 230px;
    margin-top: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .menu-items-container {
    padding: 8px 14px 18px;
  }
  .menu-items-container .section-title {
    padding: 18px 8px 8px;
    color: #59718c;
    font-size: 11px;
    letter-spacing: 0.8px;
  }
  .menu-items-container .menu-item {
    --background: rgba(255, 255, 255, 0.82);
    --min-height: 46px;
    --padding-start: 12px;
    --inner-padding-end: 12px;
    margin-bottom: 7px;
    border-radius: 11px;
    border: 1px solid rgba(148, 163, 184, 0.18);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
  }
  .menu-items-container .menu-item ion-icon {
    width: 22px;
    color: #5b7fa3;
    font-size: 20px;
  }
  .menu-items-container .menu-item ion-label {
    font-size: 14px;
    font-weight: 650;
  }
  .menu-items-container .menu-item:hover {
    --background: #eef7ff;
    transform: translateX(3px);
    border-color: rgba(36, 120, 199, 0.18);
    box-shadow: 0 12px 24px rgba(36, 120, 199, 0.11);
  }
  .menu-items-container .menu-item:hover ion-icon,
  .menu-items-container .menu-item:hover ion-label {
    color: #1f6dae;
  }
  .menu-items-container .menu-item.selected {
    --background: #e8f4ff;
    border-color: rgba(36, 120, 199, 0.26);
    box-shadow: 0 12px 26px rgba(36, 120, 199, 0.15);
  }
  .menu-items-container .menu-item.logout-item:hover {
    --background: #fff0f2;
    border-color: rgba(255, 71, 87, 0.22);
  }
  .menu-items-container .menu-item.logout-item:hover ion-icon,
  .menu-items-container .menu-item.logout-item:hover ion-label {
    color: #ff4757;
  }
  .menu-footer {
    padding: 22px 0 8px;
  }
}
.app-startup {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  background: #f5f7fb;
  color: #314661;
}
.app-startup strong {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.app-startup__loader {
  width: 30px;
  height: 30px;
  border: 3px solid #dce5ef;
  border-top-color: #2478c7;
  border-radius: 50%;
  animation: app-startup-spin 0.75s linear infinite;
}

@keyframes app-startup-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;EACA,6BAAA;AAAF;;AAGA;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wFAAA;EACA,6FACE;AADJ;;AAIA;EACE,uBAAA;EACA,kBAAA;EACA,cAAA;AADF;AAGE;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AADJ;AAIE;EACE,SAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAKE;EACE,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2CAAA;AAJF;AAME;EACE,eAAA;AAJJ;;AAQA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,8CAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,kCAAA;AALF;AAOE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;AALJ;AAQE;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;UAAA,gBAAA;AANJ;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAPF;AASE;EACE,eAAA;AAPJ;;AAWA;EACE,mBAAA;EACA,0BAAA;EACA,kCAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AARF;;AAWA;EACE,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,8CAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AARF;AAUE;EAAK,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,iBAAA;AAJ1D;AAKE;EAAM,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,mBAAA;EAAqB,gBAAA;AAEjF;AADE;EAAW,qDAAA;EAAuD,SAAA;EAAW,mBAAA;EAAqB,gDAAA;EAAkD,WAAA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,WAAA;AAYxN;;AATA;EAA6B,kBAAA;EAAoB,oBAAA;EAAsB,kBAAA;AAevE;;AAdA;EAAiC,oCAAA;EAAsC,aAAA;EAAe,YAAA;EAAc,UAAA;EAAY,YAAA;AAsBhH;;AArBA;EAAiC,mCAAA;EAAqC,aAAA;EAAe,aAAA;EAAe,WAAA;EAAa,YAAA;AA6BjH;;AA5BA;EAAuB,mBAAA;EAAqB,qDAAA;EAAuD,yBAAA;EAA2B,mBAAA;EAAqB,cAAA;EAAgB,aAAA;EAAe,YAAA;EAAc,uBAAA;EAAyB,mBAAA;EAAqB,kBAAA;EAAoB,WAAA;AA0ClQ;AA1C+Q;EAAW,eAAA;AA6C1R;;AA5CA;EAA0B,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAuB,yBAAA;AAoDpG;;AAnDA;EAAuB,mBAAA;EAAqB,mBAAA;EAAqB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,SAAA;EAAW,uBAAA;EAAyB,mBAAA;EAAqB,aAAA;EAAe,kBAAA;AAgExM;AAhE4N;EAAW,cAAA;EAAgB,eAAA;AAoEvP;AApE0Q;EAAgB,cAAA;AAuE1R;AAvE4S;EAAQ,cAAA;EAAgB,cAAA;EAAgB,yBAAA;AA4EpV;AA5EiX;EAAS,cAAA;EAAgB,eAAA;EAAiB,eAAA;AAiF3Z;;AAhFA;EAA2B,uBAAA;EAAyB,mBAAA;EAAqB,yBAAA;EAA2B,mBAAA;EAAqB,cAAA;EAAgB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,iBAAA;EAAmB,mBAAA;EAAqB,aAAA;EAAe,kBAAA;EAAoB,gBAAA;AAgG9P;AAhGgR;EAAW,cAAA;EAAgB,eAAA;AAoG3S;;AAhGE;EACE,4BAAA;AAmGJ;;AA9FA;EACE,6DAAA;EACA,4BAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;AAiGF;AA/FE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;AAiGJ;AA9FE;EACE,mBAAA;AAgGJ;AA9FI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AAgGN;AA5FE;EACE,kBAAA;EACA,UAAA;AA8FJ;AA5FI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AA8FN;AA3FI;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA6FN;AA1FI;EACE,mBAAA;EACA,qCAAA;EACA,2CAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AA4FN;AA1FM;EAAW,eAAA;AA6FjB;AA5FM;EAAY,kCAAA;EAAoC,sCAAA;EAAwC,cAAA;AAiG9F;AA9FI;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AAgGN;AA9FM;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAgGR;AA9FQ;EAAW,iBAAA;EAAmB,eAAA;AAkGtC;AAhGQ;EAAa,qCAAA;EAAuC,cAAA;EAAgB,2CAAA;AAqG5E;AApGQ;EAAe,kCAAA;EAAoC,cAAA;EAAgB,yBAAA;AAyG3E;AAxGQ;EAAiB,qCAAA;EAAuC,cAAA;EAAgB,2CAAA;AA6GhF;AA5GQ;EAAY,mBAAA;EAAqB,cAAA;EAAgB,yCAAA;AAiHzD;AA7GI;EACE,eAAA;EACA,cAAA;EACA,SAAA;AA+GN;;AAzGA;EACE,kBAAA;AA4GF;AA1GE;EACE,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA4GJ;AAzGE;EACE,uBAAA;EACA,UAAA;AA2GJ;AAvGE;EACE,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8CAAA;AAyGJ;AAvGI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAyGN;AAtGI;EACE,gBAAA;EACA,eAAA;EACA,uBAAA;AAwGN;AApGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AAsGN;AApGM;EACE,YAAA;AAsGR;AAnGM;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAqGR;AAnGQ;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAqGV;AA/FI;EACE,qCAAA;EACA,gDAAA;AAiGN;AA/FM;EACE,gCAAA;AAiGR;AA9FM;EACE,gCAAA;EACA,gBAAA;AAgGR;AA3FI;EACE,qBAAA;AA6FN;AA5FM;EAAW,cAAA;AA+FjB;AA9FM;EAAY,cAAA;EAAgB,gBAAA;AAkGlC;AA/FI;EACE,qCAAA;AAiGN;AA/FM;;EAEE,gCAAA;AAiGR;AA5FI;EACE,gBAAA;EACA,yBAAA;EACA,qBAAA;AA8FN;AA5FM;EAAW,cAAA;AA+FjB;AA9FM;EAAY,cAAA;AAiGlB;;AA3FA;EACE,kBAAA;EACA,oBAAA;AA8FF;AA5FE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA8FJ;AA3FE;EACE,eAAA;EACA,2BAAA;EACA,gBAAA;AA6FJ;AA3FI;EACE,eAAA;EACA,YAAA;AA6FN;;AAxFA;EACE;IACE,cAAA;IACA,kBAAA;IACA,qBAAA;IACA,gDAAA;EA2FF;EAzFE;IACE,6BAAA;IACA,gCAAA;IACA,gBAAA;IACA,gDAAA;IACA,8CAAA;EA2FJ;EAxFE;IACE,+DAAA;EA0FJ;EAtFA;IACE,qBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gCAAA;IACA,6FACE;IACF,8CAAA;EAuFF;EArFE;IACE,YAAA;IACA,aAAA;IACA,YAAA;IACA,aAAA;IACA,oCAAA;EAuFJ;EAnFI;IACE,eAAA;IACA,iBAAA;EAqFN;EAlFI;IACE,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EAoFN;EA/EA;IACE,sBAAA;EAiFF;EA/EE;IACE,qBAAA;IACA,cAAA;IACA,eAAA;IACA,qBAAA;EAiFJ;EA9EE;IACE,uCAAA;IACA,kBAAA;IACA,qBAAA;IACA,yBAAA;IACA,kBAAA;IACA,mBAAA;IACA,2CAAA;IACA,6CAAA;EAgFJ;EA9EI;IACE,WAAA;IACA,cAAA;IACA,eAAA;EAgFN;EA7EI;IACE,eAAA;IACA,gBAAA;EA+EN;EA5EI;IACE,qBAAA;IACA,0BAAA;IACA,sCAAA;IACA,gDAAA;EA8EN;EA5EM;;IAEE,cAAA;EA8ER;EA1EI;IACE,qBAAA;IACA,sCAAA;IACA,gDAAA;EA4EN;EAzEI;IACE,qBAAA;IACA,qCAAA;EA2EN;EAzEM;;IAEE,cAAA;EA2ER;EArEA;IACE,mBAAA;EAuEF;AACF;AArEA;EACE,eAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AAuEF;AArEE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAuEJ;;AAnEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iDAAA;AAsEF;;AAnEA;EACE;IACE,yBAAA;EAsEF;AACF","sourcesContent":["// Variáveis do Menu\r\n:host {\n  --menu-bg: #f7fafc;\n  --header-bg: #173f63;\n  --primary-color: #2478c7;\n  --text-main: #26323f;\n  --text-light: #64748b;\n  --item-hover: #eef7ff;\n  --item-selected-bg: #e8f4ff;\n  --item-selected-text: #1f6dae;\n}\n\n.mobile-web-block {\n  position: fixed;\n  inset: 0;\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: max(24px, env(safe-area-inset-top)) 20px max(24px, env(safe-area-inset-bottom));\n  background:\n    linear-gradient(180deg, rgba(23, 63, 99, 0.96) 0%, rgba(36, 120, 199, 0.96) 100%);\n}\n\n.mobile-web-panel {\n  width: min(100%, 380px);\n  text-align: center;\n  color: #ffffff;\n\n  h1 {\n    margin: 18px 0 10px;\n    font-size: 24px;\n    line-height: 1.18;\n    font-weight: 900;\n    letter-spacing: 0;\n  }\n\n  p {\n    margin: 0;\n    color: rgba(255, 255, 255, 0.86);\n    font-size: 15px;\n    line-height: 1.55;\n  }\n\n  small {\n    display: block;\n    margin-top: 16px;\n    color: rgba(255, 255, 255, 0.72);\n    font-size: 12px;\n    line-height: 1.45;\n  }\n}\n\n.mobile-web-icon {\n  width: 76px;\n  height: 76px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.24);\n\n  ion-icon {\n    font-size: 40px;\n  }\n}\n\n.mobile-web-primary {\n  width: 100%;\n  min-height: 52px;\n  margin-top: 24px;\n  border: 0;\n  border-radius: 14px;\n  background: #ffffff;\n  color: #173f63;\n  font-size: 15px;\n  font-weight: 900;\n  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.22);\n}\n\n.mobile-web-desktop-access {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-top: 20px;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 14px;\n  background: rgba(15, 23, 42, 0.16);\n\n  span {\n    color: rgba(255, 255, 255, 0.78);\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  strong {\n    color: #ffffff;\n    font-size: 16px;\n    overflow-wrap: anywhere;\n    user-select: all;\n  }\n}\n\n.mobile-web-copy {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 40px;\n  margin-top: 4px;\n  padding: 0 16px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 800;\n\n  ion-icon {\n    font-size: 18px;\n  }\n}\n\n.access-expired-overlay {\n  align-items: center;\n  backdrop-filter: blur(7px);\n  background: rgba(15, 23, 42, 0.72);\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  padding: 20px;\n  position: fixed;\n  z-index: 100000;\n}\n\n.access-expired-card {\n  background: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  border-radius: 24px;\n  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.32);\n  max-width: 430px;\n  overflow: hidden;\n  padding: 32px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n\n  h1 { color: #1e293b; font-size: 24px; line-height: 1.2; margin: 8px 0 9px; }\n  > p { color: #64748b; font-size: 14px; line-height: 1.55; margin: 0 auto 20px; max-width: 340px; }\n  > button { background: linear-gradient(135deg, #6557e8, #5044d8); border: 0; border-radius: 12px; box-shadow: 0 10px 22px rgba(101, 87, 232, 0.26); color: #fff; font-size: 14px; font-weight: 800; min-height: 46px; width: 100%; }\n}\n\n.access-expired-decoration { border-radius: 50%; pointer-events: none; position: absolute; }\n.access-expired-decoration-one { background: rgba(101, 87, 232, 0.08); height: 150px; right: -70px; top: -70px; width: 150px; }\n.access-expired-decoration-two { background: rgba(239, 68, 68, 0.06); bottom: -55px; height: 120px; left: -55px; width: 120px; }\n.access-expired-icon { align-items: center; background: linear-gradient(145deg, #fff1f2, #ffe4e6); border: 1px solid #fecdd3; border-radius: 20px; color: #e11d48; display: flex; height: 68px; justify-content: center; margin: 0 auto 14px; position: relative; width: 68px; ion-icon { font-size: 34px; } }\n.access-expired-eyebrow { color: #e11d48; font-size: 10px; font-weight: 900; letter-spacing: .11em; text-transform: uppercase; }\n.access-expired-date { align-items: center; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 13px; display: flex; gap: 10px; justify-content: center; margin-bottom: 10px; padding: 11px; position: relative; ion-icon { color: #6557e8; font-size: 21px; } small, strong { display: block; } small { color: #94a3b8; font-size: 9px; text-transform: uppercase; } strong { color: #334155; font-size: 14px; margin-top: 1px; } }\n.access-expired-guidance { align-items: flex-start; background: #f3f1ff; border: 1px solid #ddd8ff; border-radius: 13px; color: #554c9f; display: flex; font-size: 12px; gap: 8px; line-height: 1.45; margin-bottom: 18px; padding: 11px; position: relative; text-align: left; ion-icon { flex: 0 0 auto; font-size: 19px; } }\n\n// Configuração do Menu Container\nion-menu.custom-menu {\n  ion-content {\r\n    --background: var(--menu-bg);\r\n  }\r\n}\r\n\r\n// 1. CABEÇALHO DO MENU (User Profile)\r\n.menu-header {\n  background: linear-gradient(135deg, #173f63 0%, #2478c7 100%);\n  padding: 40px 20px 25px 20px; // Mais padding no topo\n  color: #ffffff;\n  border-bottom-right-radius: 30px; // Curva moderna apenas na direita\n  margin-bottom: 10px;\n  box-shadow: 0 14px 28px rgba(23, 63, 99, 0.22);\n  position: relative;\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    position: absolute;\n    right: -34px;\n    bottom: -42px;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    background: rgba(33, 166, 122, 0.28);\n  }\n\r\n  .user-avatar-container {\r\n    margin-bottom: 15px;\r\n    \r\n    .avatar-circle {\r\n      width: 60px;\r\n      height: 60px;\r\n      background: #ffffff;\r\n      border-radius: 50%;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      color: var(--header-bg);\r\n      font-weight: 800;\r\n      font-size: 24px;\r\n      box-shadow: 0 4px 10px rgba(0,0,0,0.2);\r\n    }\r\n  }\r\n\r\n  .user-details {\n    position: relative;\n    z-index: 1;\n\n    .user-name {\r\n      margin: 0;\r\n      font-size: 20px;\r\n      font-weight: 700;\r\n      letter-spacing: 0.5px;\r\n    }\r\n\r\n    .user-email {\n      margin: 4px 0 10px;\n      font-size: 13px;\n      opacity: 0.9;\n      font-weight: 500;\n    }\n\n    .access-validity {\n      align-items: center;\n      background: rgba(255, 255, 255, 0.14);\n      border: 1px solid rgba(255, 255, 255, 0.28);\n      border-radius: 9px;\n      color: #eff6ff;\n      display: inline-flex;\n      font-size: 10px;\n      font-weight: 700;\n      gap: 5px;\n      margin: 0 0 10px;\n      padding: 6px 8px;\n\n      ion-icon { font-size: 14px; }\n      &.expired { background: rgba(127, 29, 29, 0.3); border-color: rgba(254, 202, 202, 0.5); color: #fff1f2; }\n    }\n\r\n    .status-row {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 8px;\r\n      margin-bottom: 8px;\r\n\r\n      .badge {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        padding: 4px 10px;\r\n        border-radius: 20px;\r\n        font-size: 10px;\r\n        font-weight: 700;\r\n        text-transform: uppercase;\r\n        \r\n        ion-icon { margin-right: 4px; font-size: 12px; }\r\n\r\n        &.verified { background: rgba(255, 255, 255, 0.16); color: #d9fff0; border: 1px solid rgba(217, 255, 240, 0.55); }\n        &.unverified { background: rgba(255, 71, 87, 0.2); color: #ff4757; border: 1px solid #ff4757; }\n        &.current-plan { background: rgba(255, 255, 255, 0.16); color: #ffffff; border: 1px solid rgba(255, 255, 255, 0.42); }\n        &.premium { background: #fff5d7; color: #8a5a00; box-shadow: 0 2px 5px rgba(0,0,0,0.12); }\n      }\r\n    }\r\n\r\n    .plan-date {\r\n      font-size: 11px;\r\n      color: #ffd32a;\r\n      margin: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// 2. LISTAS E ITENS\r\n.menu-items-container {\r\n  padding: 10px 16px; // Espaçamento lateral para os itens \"respirarem\"\r\n\r\n  .section-title {\r\n    padding: 20px 10px 5px;\r\n    font-size: 12px;\r\n    text-transform: uppercase;\r\n    color: #7a8da4;\n    font-weight: 700;\r\n    letter-spacing: 1px;\r\n  }\r\n\r\n  ion-list {\r\n    background: transparent;\r\n    padding: 0;\r\n  }\r\n\r\n  // Estilo Base do Item\r\n  .menu-item {\r\n    --background: #ffffff;\n    --min-height: 48px;\r\n    --padding-start: 12px;\r\n    --inner-padding-end: 12px;\n    margin-bottom: 6px;\n    border-radius: 12px; // Efeito \"Pílula\"\r\n    transition: all 0.2s ease;\n    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.035);\n\r\n    ion-icon {\r\n      color: #6b8aab;\n      font-size: 22px;\r\n      margin-right: 12px;\r\n    }\r\n\r\n    ion-label {\r\n      font-weight: 500;\r\n      font-size: 15px;\r\n      color: var(--text-main);\r\n    }\r\n\r\n    // Badge \"NOVO\" dentro do item\r\n    .label-badge-container {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      gap: 10px;\n\n      ion-label {\n        min-width: 0;\n      }\n\n      .mini-badge {\n        background: #e8f4ff;\n        color: #2478c7;\n        font-size: 9px;\n        padding: 2px 6px;\n        border-radius: 8px;\n        font-weight: bold;\n        flex-shrink: 0;\n        letter-spacing: 0;\n\n        &.beta-badge {\n          background: #fff7ed;\n          border: 1px solid #fed7aa;\n          color: #b45309;\n        }\n      }\n    }\n\r\n    // Estado Selecionado (Active)\r\n    &.selected {\n      --background: var(--item-selected-bg);\n      box-shadow: 0 10px 20px rgba(36, 120, 199, 0.14);\n      \r\n      ion-icon {\r\n        color: var(--item-selected-text);\r\n      }\r\n      \r\n      ion-label {\r\n        color: var(--item-selected-text);\r\n        font-weight: 700;\r\n      }\r\n    }\r\n\r\n    // Item Especial (Premium)\r\n    &.highlight-item {\n      --background: #fff8e5;\n      ion-icon { color: #b7791f; }\n      ion-label { color: #8a5a00; font-weight: 700; }\n    }\n\n    &.highlight-item.selected {\n      --background: var(--item-selected-bg);\n\n      ion-icon,\n      ion-label {\n        color: var(--item-selected-text);\n      }\n    }\n\r\n    // Item Sair\r\n    &.logout-item {\r\n      margin-top: 15px;\r\n      border: 1px solid #ffe2e5;\n      --background: #fff7f8;\n      \r\n      ion-icon { color: #ff4757; }\r\n      ion-label { color: #ff4757; }\r\n    }\r\n  }\r\n}\r\n\r\n// 3. RODAPÉ DO MENU\r\n.menu-footer {\n  text-align: center;\n  padding: 30px 0 10px;\n  \r\n  p {\r\n    font-size: 12px;\r\n    color: #8ea0b4;\n    margin: 0 0 5px;\r\n  }\r\n\r\n  .links-row {\r\n    font-size: 11px;\r\n    color: var(--primary-color);\r\n    font-weight: 600;\r\n    \r\n    span {\r\n      cursor: pointer;\r\n      padding: 5px;\r\n    }\n  }\n}\n\n@media (min-width: 1024px) {\n  ion-menu.custom-menu {\n    --width: 320px;\n    --max-width: 320px;\n    --background: #f8fafc;\n    --box-shadow: 18px 0 45px rgba(15, 23, 42, 0.18);\n\n    &::part(container) {\n      border-top-right-radius: 22px;\n      border-bottom-right-radius: 22px;\n      overflow: hidden;\n      border-right: 1px solid rgba(36, 120, 199, 0.16);\n      box-shadow: 18px 0 45px rgba(15, 23, 42, 0.18);\n    }\n\n    ion-content {\n      --background: linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);\n    }\n  }\n\n  .menu-header {\n    margin: 14px 14px 8px;\n    padding: 24px 18px 20px;\n    border-radius: 18px;\n    border-bottom-right-radius: 18px;\n    background:\n      linear-gradient(145deg, rgba(23, 63, 99, 0.96) 0%, rgba(36, 120, 199, 0.94) 100%);\n    box-shadow: 0 16px 32px rgba(23, 63, 99, 0.22);\n\n    &::after {\n      right: -42px;\n      bottom: -54px;\n      width: 140px;\n      height: 140px;\n      background: rgba(33, 166, 122, 0.26);\n    }\n\n    .user-details {\n      .user-name {\n        font-size: 18px;\n        letter-spacing: 0;\n      }\n\n      .user-email {\n        max-width: 230px;\n        margin-top: 6px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n  }\n\n  .menu-items-container {\n    padding: 8px 14px 18px;\n\n    .section-title {\n      padding: 18px 8px 8px;\n      color: #59718c;\n      font-size: 11px;\n      letter-spacing: 0.8px;\n    }\n\n    .menu-item {\n      --background: rgba(255, 255, 255, 0.82);\n      --min-height: 46px;\n      --padding-start: 12px;\n      --inner-padding-end: 12px;\n      margin-bottom: 7px;\n      border-radius: 11px;\n      border: 1px solid rgba(148, 163, 184, 0.18);\n      box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);\n\n      ion-icon {\n        width: 22px;\n        color: #5b7fa3;\n        font-size: 20px;\n      }\n\n      ion-label {\n        font-size: 14px;\n        font-weight: 650;\n      }\n\n      &:hover {\n        --background: #eef7ff;\n        transform: translateX(3px);\n        border-color: rgba(36, 120, 199, 0.18);\n        box-shadow: 0 12px 24px rgba(36, 120, 199, 0.11);\n\n        ion-icon,\n        ion-label {\n          color: #1f6dae;\n        }\n      }\n\n      &.selected {\n        --background: #e8f4ff;\n        border-color: rgba(36, 120, 199, 0.26);\n        box-shadow: 0 12px 26px rgba(36, 120, 199, 0.15);\n      }\n\n      &.logout-item:hover {\n        --background: #fff0f2;\n        border-color: rgba(255, 71, 87, 0.22);\n\n        ion-icon,\n        ion-label {\n          color: #ff4757;\n        }\n      }\n    }\n  }\n\n  .menu-footer {\n    padding: 22px 0 8px;\n  }\n}\n.app-startup {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  background: #f5f7fb;\n  color: #314661;\n\n  strong {\n    font-size: 22px;\n    font-weight: 700;\n    letter-spacing: -0.3px;\n  }\n}\n\n.app-startup__loader {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #dce5ef;\n  border-top-color: #2478c7;\n  border-radius: 50%;\n  animation: app-startup-spin 0.75s linear infinite;\n}\n\n@keyframes app-startup-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
